export interface PurchaserPortalKeyFormValues {
  portalKeyName: string;
  portalKey: string;
}

export const EMPTY_PORTAL_KEY_FORM_VALUES: PurchaserPortalKeyFormValues = {
  portalKeyName: "",
  portalKey: "",
};

export const PORTAL_KEY_NAME_MAX_LENGTH = 255;
export const PORTAL_KEY_MAX_LENGTH = 100;
export const PORTAL_KEY_PATTERN = /^[A-Z]+(_[A-Z]+)*$/;
export const PORTAL_KEY_FORMAT_MESSAGE =
  "Only uppercase letters and underscores are allowed";
export const PORTAL_KEY_NAME_REQUIRED_MESSAGE = "Portal key name is required";
export const PORTAL_KEY_NAME_MAX_MESSAGE = `Portal key name must not exceed ${PORTAL_KEY_NAME_MAX_LENGTH} characters`;
export const PORTAL_KEY_REQUIRED_MESSAGE = "Portal key is required";
export const PORTAL_KEY_MAX_MESSAGE = `Portal key must not exceed ${PORTAL_KEY_MAX_LENGTH} characters`;

const PORTAL_KEY_DISALLOWED_CHARS = /[^A-Z_]/g;

function trimEdgeUnderscores(value: string): string {
  let start = 0;
  let end = value.length;
  while (start < end && value[start] === "_") {
    start += 1;
  }
  while (end > start && value[end - 1] === "_") {
    end -= 1;
  }
  return value.slice(start, end);
}

export function generatePortalKeyFromName(name: string): string {
  const key = trimEdgeUnderscores(
    name
      .trim()
      .toUpperCase()
      .replaceAll(/\s+/g, "_")
      .replaceAll(PORTAL_KEY_DISALLOWED_CHARS, "")
      .replaceAll(/_+/g, "_"),
  );
  if (key.length <= PORTAL_KEY_MAX_LENGTH) {
    return key;
  }
  return trimEdgeUnderscores(key.slice(0, PORTAL_KEY_MAX_LENGTH));
}

export function sanitizePortalKeyInput(raw: string): string {
  return raw
    .toUpperCase()
    .replaceAll(/\s+/g, "_")
    .replaceAll(PORTAL_KEY_DISALLOWED_CHARS, "")
    .replaceAll(/_+/g, "_");
}

export function formatPortalKey(raw: string): string {
  return trimEdgeUnderscores(sanitizePortalKeyInput(raw));
}

export function isPortalKeyFormSubmittable(
  mode: "create" | "edit",
  values: PurchaserPortalKeyFormValues,
  initialName: string,
): boolean {
  const name = values.portalKeyName.trim();
  if (!name || name.length > PORTAL_KEY_NAME_MAX_LENGTH) {
    return false;
  }

  if (mode === "create") {
    const portalKey = values.portalKey.trim();
    return (
      PORTAL_KEY_PATTERN.test(portalKey) &&
      portalKey.length <= PORTAL_KEY_MAX_LENGTH
    );
  }

  return name !== initialName.trim();
}
